var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("微信扫码，添加客服")]),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":require("../../assets/images/kf.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }